import i18n from '../i18n'

const BASE_URL = process.env.REACT_APP_API_URL
const BASE_ADMIN_URL = process.env.REACT_APP_ADMIN_URL
const WS_URL = process.env.REACT_APP_API_WS_URL
const REFRESH_TOKEN_URL = BASE_URL + '/oauth/token'
const DEFAULT_PARAMS = { lang: i18n.language }

const Api = {
  BASE_ADMIN_URL,
  BASE_URL,
  DEFAULT_PARAMS,
  REFRESH_TOKEN_URL,
  WS_URL
}

export default Api
